module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAU9JREFUKBWNkr1KxEAUhTfJpBSVFCm0tvUdrGy1EkFtFpaI7CtswEZ8gWwWRbBYhBQ+QVBREOxUrG23U7HKkh+/KW4Y1mR14HJu7jln5s7NWHEcL3Y6nQGxSjSuqqos1kuWZaf9fj8TkSrLcgtiA8EJWAlhIpyCO1ZK3VK/F06RLBM3QRBcSbEJh8Phnm3bSyZns2NJ6E3mLjSXdPlmiv40ibjX640lF7Ql+Q8y3G4URUeinXtyGIazmz/Q/pj755PJZNRqRrCJMGTS9R8gnVJb4OTI9/3XVjOiRwbUlRY1YvYcxxmB53DPrWYG9IVeR73o5hDjXZqmQZIkRau5dhgJ9zxjDlMpzQ5E6r+QSe96nrdiEoo29Aa5WWzK0e27rvsN9y68bvuDOOD/7TCkerIi0IhRv+21oig+zbrivV5DroPbJjGTW3xf5Hn+ZNZ/ANFcgsiyDx10AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/exit.png
// module id = VEp3
// module chunks = 1